import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useMainNavContext } from '../MainNavContext/index.js';
import { MainNavLink } from '../MainNavLink/index.js';

var MainNavMenuLink = forwardRef(function (props, forwardedRef) {
    var themeKey = useMainNavContext().themeKey;
    return (jsx(MainNavLink, __assign({ ref: forwardedRef, themeKey: "".concat(themeKey, "MenuItem") }, props)));
});
MainNavMenuLink.displayName = "MainNavMenuLink";

export { MainNavMenuLink };
//# sourceMappingURL=MainNavMenuLink.js.map
